/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {AuthPage, Logout} from '../modules/auth'
import React, {FC} from 'react'
import {Redirect, Route, Switch, useLocation} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'

import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {MasterInit} from '../../_metronic/layout/MasterInit'
import {PrivateRoutes} from './PrivateRoutes'
import {PublicRoutes} from './PublicRoutes'
import {RootState} from 'setup/redux/RootReducer'
import { ROLE_GENERAL } from 'utils/constants'

const Routes: FC = () => {
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const role: string = (useSelector<RootState>(({auth}) => auth.user?.role, shallowEqual) as string) || '';

  return (
    <>
      <Switch>
        {!isAuthorized ? (
          <Route>
            <AuthPage />
          </Route>
        ) : (
          <Redirect from='/auth' to='/' />
        )}
        <Route path='/error' component={ErrorsPage} />
        <Route path='/logout' component={Logout} />
        {
          !isAuthorized ? (
            <Redirect to='/auth/login' />
          ) : ([ROLE_GENERAL.ADMIN, ROLE_GENERAL.SUPER_ADMIN, ROLE_GENERAL.USER_DEFAULT].includes(role)) 
                ? (<PrivateRoutes />) 
                : (<PublicRoutes />)
        }
      </Switch>
      <MasterInit />
    </>
  )
}

export {Routes}
